/** Two-letter locale segment at start of path, e.g. /gb/movies/... */
export function regionFromPathname(pathname) {
  const parts = String(pathname || '').split('/').filter(Boolean);
  const first = (parts[0] || '').toLowerCase();
  if (!first) return '';
  const reserved = [
    'search',
    'movies',
    'tv',
    'anime',
    'explore',
    'category',
    'categories',
    'compare',
    'about',
    'contact',
    'privacy',
    'terms',
    'faq',
    'profile',
    'dashboard',
    'login',
    'register',
    'similar',
    'top',
  ];
  if (reserved.includes(first)) return '';
  if (/^[a-z]{2}$/.test(first)) return first;
  return '';
}
